export default __webpack_public_path__ + "static/media/mars16.3afbc32a.gif";